import React from 'react';
import {Button, Icon} from 'semantic-ui-react';

import Link from '@appComponents/Link';

const AdSpliceEditButtons = () => {
    return (
        <div className='content__buttons'>
            <Link name='adSplice.index'>
                <Button className='button-back'>
                    <Icon className='arrow circle left'/> Back to list
                </Button>
            </Link>
        </div>
    );
};

export default AdSpliceEditButtons;
